import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const Footer = () => {
  const [settings, setSettings] = useState({
    company_name: 'HYPA MOTORS',
    phone: '+250 783 044 172',
    email: 'info@hypamotors.com',
    address: 'Kigali, Rwanda',
    footer_text: '© 2024 HYPA MOTORS. All rights reserved.',
    business_hours: 'Monday - Friday: 8:00 - 18:00',
    support_24_7: '24/7 Customer Support',
    facebook_url: '#',
    twitter_url: '#',
    instagram_url: '#'
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/settings/public`);
      setSettings(prev => ({ ...prev, ...response.data }));
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  return (
    <footer className="bg-dark-900 text-white pt-12 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="bg-orange-500 p-2 rounded-lg w-10 h-10 flex items-center justify-center">
                <span className="text-white font-bold text-lg">HM</span>
              </div>
              <h3 className="text-xl font-bold">{settings.company_name || 'HYPA MOTORS'}</h3>
            </div>
            <p className="text-gray-400 mb-4">Experience the Ultimate SUV. Drive in Luxury with Rwanda's premier car rental and tourism company.</p>
            <div className="flex space-x-3">
              <a href={settings.facebook_url} className="bg-dark-800 w-8 h-8 rounded-full hover:bg-orange-500 transition flex items-center justify-center text-gray-400 hover:text-white">
                <span className="text-xs">f</span>
              </a>
              <a href={settings.twitter_url} className="bg-dark-800 w-8 h-8 rounded-full hover:bg-orange-500 transition flex items-center justify-center text-gray-400 hover:text-white">
                <span className="text-xs">t</span>
              </a>
              <a href={settings.instagram_url} className="bg-dark-800 w-8 h-8 rounded-full hover:bg-orange-500 transition flex items-center justify-center text-gray-400 hover:text-white">
                <span className="text-xs">ig</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-orange-500 transition">Home</Link></li>
              <li><Link to="/cars" className="text-gray-400 hover:text-orange-500 transition">Our Fleet</Link></li>
              <li><Link to="/tours" className="text-gray-400 hover:text-orange-500 transition">Tour Packages</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-orange-500 transition">Contact Us</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-orange-500 transition">About Us</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3 text-gray-400">
                <Phone size={18} />
                <span>{settings.phone}</span>
              </li>
              <li className="flex items-center space-x-3 text-gray-400">
                <Mail size={18} />
                <span>{settings.email}</span>
              </li>
              <li className="flex items-center space-x-3 text-gray-400">
                <MapPin size={18} />
                <span>{settings.address}</span>
              </li>
            </ul>
          </div>

          {/* Business Hours */}
          <div>
            <h4 className="text-lg font-bold mb-4">Business Hours</h4>
            <ul className="space-y-2 text-gray-400">
              {settings.business_hours?.split(',').map((hour, index) => (
                <li key={index}>{hour.trim()}</li>
              ))}
              <li className="text-orange-500 mt-2">{settings.support_24_7}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-dark-800 pt-6 text-center text-gray-400">
          <p>{settings.footer_text}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;